export const FIRESTORE_GOT_DATA = 'FIRESTORE_GOT_DATA';
export const FIRESTORE_ADD_LISTENER = 'FIRESTORE_ADD_LISTENER';
export const FIRESTORE_DOC_CHANGED = 'FIRESTORE_DOC_CHANGED';

